import React, { useContext, useState, useEffect, useRef } from "react";
import { getDomainAndClientWiseAccounts } from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL, PROJECT_DISPLAY_NAME } from "../../../config/apiConfig";
import { Link, useNavigate } from "react-router-dom";
import ScreenLoader from "../../HtmlElements/ScreenLoader";
import { Form, Modal, Button, Row, Col } from "react-bootstrap";
import { getCheckoutClientInfo, saveCheckoutClientInfo } from "../../../services/authService";
import * as FeatherIcon from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { submitDemoRequest } from "../../../store/features/actions/demoRequestActions";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Alert from "../../HtmlElements/Alert";
import AddDemoRequest from "../../DemoRequests/AddDemoRequest";

export default function AllSalesAccounts() {
  const dispatch = useDispatch();
  const { loading, successMessage, errorMessage } = useSelector(state => state.demoRequestReducer);
  const { user, setUser } = useUser();
  const [domainWiseClientsAndAccounts, setDomainWiseClientsAndAccounts] =
    useState([]);
  const [selectedDomainIndex, setSelectedDomainIndex] = useState(null);
  const [selectedClientCode, setSelectedClientCode] = useState(null);
  const [selectedClientName, setSelectedClientName] = useState(null);
  const [selectedClientKSCompanyCode, setSelectedClientKSCompanyCode] = useState(null);
  const [selectedClientKSCompanyName, setSelectedClientKSCompanyName] = useState(null);
  const [accountList, setAccountList] = useState([]);
  const [searchFilters, setSearchFilters] = useState({'search_string': ''})
  const [debouncedSearch, setDebouncedSearch] = useState(searchFilters.search_string);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const [showDescriptionModal, setShowModal] = useState(false);

  const [success_message, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [customError, setCustomError] = useState({});

  const fetchAndSetDomainAndClientWiseAccounts = async (debouncedSearch) => {
    const domainWiseClientsAndAccounts = await getDomainAndClientWiseAccounts(debouncedSearch);
    setDomainWiseClientsAndAccounts(domainWiseClientsAndAccounts);
  };

  useEffect(() => {
    if (user?.role_key === "SALES_DEMO") {
      setAccountList([])
      setSelectedDomainIndex("");
      fetchAndSetDomainAndClientWiseAccounts(debouncedSearch);
    }
  }, [user?.role_key, debouncedSearch]);

  const handleSelectedDomainIndex = (index) => {
    setSelectedDomainIndex(index);
  };

  const handleSearchInput = (e) => {
     setSearchFilters({ ...searchFilters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchFilters.search_string);
    }, 500); // Delay API call by 500ms

    return () => clearTimeout(handler); // Cleanup timeout on every keypress
  }, [searchFilters.search_string]);


  const handleSelectClient = (account_code, account_name, ks_company_code, ks_company_name) => {

    setSelectedClientCode(account_code);
    setSelectedClientName(account_name);
    setSelectedClientKSCompanyCode(ks_company_code);
    setSelectedClientKSCompanyName(ks_company_name);
  };

  const handleCheckoutToAccounts = () => {

    saveCheckoutClientInfo(selectedClientCode, selectedClientName, selectedClientKSCompanyCode, selectedClientKSCompanyName)

    const checkoutClientInfo = getCheckoutClientInfo();

    user.checkoutClientInfo = checkoutClientInfo;

    setUser(user)

    navigate('/clients_accounts/'+selectedClientCode+"/"+selectedClientName);
  }

  useEffect(() => {
    if (domainWiseClientsAndAccounts.length) {
      handleSelectedDomainIndex(0);
    }
  }, [domainWiseClientsAndAccounts]);

  useEffect(() => {
    if (
      selectedDomainIndex !== null &&
      domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]
        ?.client_code
    ) {
      handleSelectClient(
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]
          ?.client_code,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]
          ?.client_name,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]
          ?.ks_company_code,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]
          ?.ks_company_name,
      );
    }
  }, [selectedDomainIndex]);

  const goToAccountDetails = (account_id, account_name) => {

    const selectedClientCodeIndex = domainWiseClientsAndAccounts[
      selectedDomainIndex
    ]?.clients.findIndex((client) => client.client_code === selectedClientCode);
    
    if (
      selectedDomainIndex !== null &&
      domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
        ?.client_code
    ) {
      handleSelectClient(
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.client_code,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.client_name,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.ks_company_code,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.ks_company_name,
      );

      saveCheckoutClientInfo(
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
        ?.client_code, 
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
        ?.client_name, 
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.ks_company_code,
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[selectedClientCodeIndex]
          ?.ks_company_name
      )

      const checkoutClientInfo = getCheckoutClientInfo();

      user.checkoutClientInfo = checkoutClientInfo;

      setUser(user)

      setTimeout(() => {
        navigate(`/account_details/${account_id}/${account_name}/${selectedClientName}`)
      }, 1500)

    }
  }

  useEffect(() => {
    setLoader(true);
    const selectedClientCodeIndex = domainWiseClientsAndAccounts[
      selectedDomainIndex
    ]?.clients.findIndex((client) => client.client_code === selectedClientCode);

    if (
      selectedDomainIndex !== null &&
      selectedClientCode !== null &&
      domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[
        selectedClientCodeIndex
      ]?.accounts?.length
    ) {
      //    handleSelectClient(domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[0]?.client_code)
      setAccountList(
        domainWiseClientsAndAccounts[selectedDomainIndex]?.clients?.[
          selectedClientCodeIndex
        ]?.accounts
      );
    }

    setTimeout(() => {
      setLoader(false);
    }, 1000);

  }, [selectedDomainIndex, selectedClientCode]);

  const handleClose = () => {
    setShowModal(false);
  };

  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return; // Skip on initial load
    }

    if (successMessage?.data?.result?.message === "Demo request added successfully") {
      setSuccessMessage("Request added successfully !");
      const timer = setTimeout(() => {
        setSuccessMessage("");
      }, 4000);
      return () => clearTimeout(timer); // clean up
    }

    if (errorMessage) {
      setError(errorMessage);
      const timer = setTimeout(() => {
        setError("");
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [successMessage, errorMessage]);

  return (
    <div>
      <div className="new_login_page">
        <div className="container-fluid">
          {loader === true && <ScreenLoader />}

          <div className="row">
            <div className="col-md-12 align-right">
              <div
                className="col-md-12 pt-2 mr-2"
                style={{ 
                  // display: "inline",
                  textAlign: 'center'
                }}
              >
                {success_message && <Alert type="success" message={success_message} />}
                {error && <Alert type="danger" message={error} />}
              </div>

              {user?.role_key === "SALES_DEMO" && (<div
                className="col-md-6 pt-2 mr-2 request_demo_link_container"
              >
                <Link className="request_demo_link" to="/demo_requests">My Requests</Link>
                <span className="request_demo_link ml-2" onClick={(e) => setShowModal(true)}>
                  Request demo
                </span>
              </div>)}
              <div
                className="new_search_custom"
                style={{ display: "inline-block" }}
              >
                <input
                  type="text"
                  className="sales_search_input"
                  name="search_string"
                  placeholder="Search by Clients or Accounts"
                  value={searchFilters?.search_string}
                  onChange={handleSearchInput}
                />
                <FeatherIcon.Search className="seach_new_login" />
              </div>
            </div>
          </div>

          <div className="custom_card_block">
            {domainWiseClientsAndAccounts.length > 0 ? (
              <div className="three_block_flex">
                <div className="industry_block">
                  <div className="div_head">
                    <h5 className="head">Industry</h5>
                  </div>
                  <div className="list_ind_block">
                    <ul className="list_trends_ul">
                      {domainWiseClientsAndAccounts.length > 0 &&
                        domainWiseClientsAndAccounts.map(
                          (domainData, index) => {
                            const domainImage = domainData.company_domain
                              .toLowerCase()
                              .replace(/[^a-z0-9]+/g, "_");

                            return (
                              <li
                                key={`domain_key_${index}`}
                                className={`list_trends_li ${
                                  index == selectedDomainIndex ? "active" : ""
                                }`}
                                onClick={() => handleSelectedDomainIndex(index)}
                              >
                                <img
                                  src={`/img/indu_icon/${domainImage}.png`}
                                  alt="icon"
                                  className="icon"
                                />
                                <span className="trend_name">
                                  {domainData.company_domain} (
                                  {domainData.clients_count})
                                </span>
                              </li>
                            );
                          }
                        )}
                    </ul>
                  </div>
                </div>
                <div className="clients_block">
                  <div className="div_head">
                    <h5 className="head">Clients</h5>
                  </div>
                  <div className="client_list_ind_block">
                    <ul className="client_list_trends_ul">
                      {selectedDomainIndex !== null &&
                        domainWiseClientsAndAccounts[selectedDomainIndex]
                          ?.clients?.length > 0 &&
                        domainWiseClientsAndAccounts[
                          selectedDomainIndex
                        ]?.clients?.map((clientData, index) => {
                          return (
                            <li
                              key={`client_list_key_${index}`}
                              className={`client_list_trends_li ${
                                clientData.client_code === selectedClientCode
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() =>
                                handleSelectClient(
                                  domainWiseClientsAndAccounts[
                                    selectedDomainIndex
                                  ]?.clients?.[index]?.client_code,
                                  domainWiseClientsAndAccounts[
                                    selectedDomainIndex
                                  ]?.clients?.[index]?.client_name,
                                  domainWiseClientsAndAccounts[
                                    selectedDomainIndex
                                  ]?.clients?.[index]?.ks_company_code,
                                  domainWiseClientsAndAccounts[
                                    selectedDomainIndex
                                  ]?.clients?.[index]?.ks_company_name
                                )
                              }
                            >
                              <span className="client_trend_name">
                                {clientData?.client_name} (
                                {clientData?.account_count})
                              </span>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
                <div className="sales_block">
                  <div className="div_head d-flex justify-content-between">
                    <h5 className="head">{PROJECT_DISPLAY_NAME}</h5>
                    <Button
                      className="btn-checkout-accounts btn btn-sm mr-1"
                      onClick={() => handleCheckoutToAccounts()}
                    >
                      {" "}
                      {PROJECT_DISPLAY_NAME} <FeatherIcon.ArrowRight className="fa" />
                    </Button>
                  </div>
                  <div className="sales_list_block">
                    {loader === false && (
                      <div className="row">
                        {selectedDomainIndex !== null &&
                          accountList?.length > 0 &&
                          accountList?.map((accountData, index) => {
                            return (
                              <div
                                key={`account_list_key_${index}`}
                                className="col-md-3"
                              >
                                <div className="logo_block">
                                  <div className="com_logo">
                                    <span
                                      className="account_title_link cursorP"
                                      onClick={() =>
                                        goToAccountDetails(
                                          accountData._id,
                                          accountData.account_name
                                        )
                                      }
                                      // to={`/account_details/${accountData._id}/${accountData.account_name}/${selectedClientName}`}
                                    >
                                      <img
                                        src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                          accountData?.account_name
                                        )}`}
                                        alt="icon"
                                        className="icon"
                                      />
                                    </span>
                                  </div>
                                  <div className="com_name_block">
                                    <h5 className="comp_name">
                                      <span
                                        className="account_title_link cursorP"
                                        onClick={() =>
                                          goToAccountDetails(
                                            accountData._id,
                                            accountData.account_name
                                          )
                                        }
                                        // to={`/account_details/${accountData._id}/${accountData.account_name}/${selectedClientName}`}
                                      >
                                        {accountData?.account_name}
                                      </span>
                                    </h5>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="mb-3 ml-4 mb-3 ml-4 text-center"
                style={{ minHeight: "350px" }}
              >
                No Client or Acount found.
              </div>
            )}
          </div>
        </div>
      </div>

      { showDescriptionModal && (<AddDemoRequest handleClose={handleClose} />) }
    </div>
  );
}
